export default "__VITE_ASSET__d2a3a64b__"